const nudgytAgentConfig = {
  baseUrl:
    process.env.REACT_APP_NUDGYT_AGENT_API_URL ||
    'https://nudgytai.onrender.com',
  maxReconnectAttempts: 5,
  reconnectDelay: 6000
};

export default nudgytAgentConfig;
